import styled from 'styled-components'

export const SiteLayoutContent = styled.div`
  background: #fff;
  height: 100%;
  overflow: hidden;
  iframe{
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
  }
`

export const ContainerImage = styled.div`
  /* Fora do fluxo flex: assim a logo nao empurra o titulo para fora do centro. */
  position: absolute;
  left: 10%;
  top: 0;
  bottom: 0;
  width: fit-content;
  display: flex;
  align-items: center;
  img{
    height: 60px;
    width: auto;
    max-width: 220px;
    object-fit: contain;
    display: block;
  }
  span{
    margin-left: 20px;
    font-size: 0.8rem;
    font-weight: 700;
  }
`

interface IframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  title: string; // Aqui adicionamos 'title' como uma propriedade obrigatória
}

export const Iframe = styled.iframe<IframeProps>`
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
`;

export const HideBar = styled.div`
  z-index: 1000;
  height: 60px;
  transform: translateY(-54px);
  background-color: white;
`
export const MenuContainer = styled.div`
  /* Fora do fluxo flex: o menu (admin) tambem nao desloca o titulo do centro. */
  position: absolute;
  right: 10%;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: fit-content;
  span{
    font-size: 0.8rem;
    font-weight: 700;
  }
`
export const ContainerWord = styled.div`
  /* Unico item no fluxo do Header (logo e menu sao absolutos) -> o justify-content:
     center do Header o deixa no centro real da tela. */
  width: fit-content;
  font-weight: 700;
  font-size: 24px;
`
